<template>
  <div>
    <div class="content_project project_opration project-logs">
      <w-row :gutter="24" class="prj-search">
        <w-col :span="8">
          <label for="datapicker" style="display: block; width: 56px;line-height: 32px;float: left;">时间段</label>
          <div class="inline-block" style="width: calc(100% - 56px)">
            <w-row :gutter="16">
              <w-col :span="11">
                <vue-datepicker-local :inputClass="['border-radius-4']" format="YYYY/MM/DD" clearable v-model="fromTime" @input="onDateChange" placeholder="请选择开始时间" style="width: 100%;"></vue-datepicker-local>
              </w-col>
              <w-col class="text-align-center" :span="2" style="line-height: 32px;">~</w-col>
              <w-col :span="11">
                <vue-datepicker-local :inputClass="['border-radius-4']" format="YYYY/MM/DD" clearable v-model="toTime" @input="onDateChange" placeholder="请选择结束时间" style="width: 100%;"></vue-datepicker-local>
              </w-col>
            </w-row>
          </div>
        </w-col>
        <w-col :span="4">
          <label for="datapicker" style="display: inline-block; width: 43px;">操作</label>
          <w-select size="small" v-model="operateType" placeholder="全部" style="width: calc(100% - 43px)">
            <w-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </w-option>
          </w-select>
        </w-col>
        <w-col :span="5">
          <label for="datapicker" style="display: inline-block; width: 72px;">操作详情</label>
          <w-input size="small" v-model="detail" placeholder="请输入操作详情" style="width: calc(100% - 72px)">
          </w-input>
        </w-col>
        <w-col :span="5">
          <label for="datapicker" style="display: inline-block; width: 86px;">操作者账号</label>
          <w-input size="small" v-model="account" placeholder="请输入完整账号" style="width: calc(100% - 86px)">
          </w-input>
        </w-col>
        <w-col class="text-align-right" :span="2">
          <w-button type="primary" @click="onSubmit(true)">查询</w-button>
        </w-col>
      </w-row>
      <Table :height="tableHeight" :fixedTable="true"
             :showNoData="tableData.length === 0" :type="2" no-data-text="暂无数据">
        <thead slot="header">
        <tr>
          <th class="text-align-left" width="150">
            <span class="person-sort" @click="sortChange()">
              时间
              <template>
                <i class="sort" :class="+sortType === 0 ? 'sort-down': 'sort-up'"></i>
              </template>
            </span>
          </th>
          <th class="text-align-left" width="100">操作</th>
          <th class="text-align-left" width="250" style="text-align: left;">操作详情</th>
          <th class="text-align-left" width="80">类型</th>
          <th class="text-align-left" width="200">
            操作者账号
          </th>
          <th class="text-align-left" width="80">登录地区</th>
          <th class="text-align-left" width="100">
            登录IP
          </th>
        </tr>
        </thead>
        <tbody slot="body" :class="{jiliangTab: +fileType === 2, size_96: +fileType === 2}">
        <tr
          v-for="(item,index) in tableData"
          :key="'tr_' + index + refreshIndex"
          height="40"
          class="text-align-left trItem"
        >
          <td width="150">
            {{item.operateTime | formatDate}}
          </td>
          <td class="text-align-left" width="100" align="left">{{item.operateType | formatType}}</td>
          <td class="text-align-left" width="250" align="left">{{item.detail}}</td>
          <td class="text-align-left" width="80" align="center">{{item.type}}</td>
          <td class="text-align-left" width="200" align="center">{{item.account}}</td>
          <td class="text-align-left" width="80" align="center">{{item.area}}</td>
          <td class="text-align-left" width="100" align="center">{{item.ip}}</td>
        </tr>
        </tbody>
      </Table>
      <div class="opration_page" v-if="total>count">
        <w-pagination
          class="page"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[50, 100]"
          :page-size=count
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page=page
        >
        </w-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import VueDatepickerLocal from 'vue-datepicker-local'
import companyProjectService from '@/assets/service/records'
import {formatDate} from '@/assets/utils/Date'
import Table from '_c/common/Table/Index.vue'
import moment from 'moment'
const operateType = {
  1: '下载',
  2: '删除',
  3: '彻底删除',
  4: '清空回收站',
  5: '还原',
  6: '重命名',
  7: '移动',
  8: '预览工程',
  9: '预览模型',
  10: '新建项目',
  11: '删除项目',
  12: '重命名项目',
  13: '添加成员',
  14: '删除成员',
  15: '修改项目编号',
  16: '修改项目类型',
  17: '修改项目进度',
  18: '修改项目概况'
}
let projectId
export default {
  name: 'ProjectLogs',
  data () {
    return {
      fromTime: '',
      toTime: '',
      operateType: '',
      account: null,
      detail: null,
      total: 0,
      page: 1,
      count: 50,
      tableData: [],
      loading: '正在加载，请稍等...',
      showPage: true,
      tableHeight: '500px',
      options: [],
      sortType: 0,
      emptyLogo: false,
      pagination: {
        total: 0,
        pageSize: 20,
        defaultPageSize: 50,
        pageSizeOptions: ['50', '100'],
        showSizeChanger: true,
        showQuickJumper: true
      },
      sorter: 'descend'
    }
  },
  components: {
    Table,
    VueDatepickerLocal
  },
  methods: {
    // 1.1 日期
    onDateChange (data) {
      this.sentLog(100112054)
    },
    // 1.2 时间排序
    sortChange () {
      if (this.sortType === 0) {
        this.sortType = 1
      } else {
        this.sortType = 0
      }
      this.onSubmit()
    },
    // 1.5 查询
    onSubmit (val) {
      this.page = 1
      this.showPage = false
      this.getOprationList()
      this.sentLog(100112055)
    },
    // 1.6 分页
    handleSizeChange (val) {
      this.count = val
      this.getOprationList()
    },
    // 1.7 分页
    handleCurrentChange (index) {
      this.page = index
      this.getOprationList()
    },
    // 1.8 获取操作列表数据
    getOprationList () {
      this.loading = '正在加载，请稍等...'
      let param = {
        projectId: projectId,
        operateType: this.operateType ? this.operateType : null,
        detail: this.detail ? this.detail : null,
        account: this.account ? this.account : null,
        pageNum: this.page,
        pageSize: this.count,
        sortType: this.sortType
      }
      if (this.fromTime) {
        param.fromTime = new Date(moment(this.fromTime).format('YYYY/MM/DD')).getTime()
      }
      if (this.toTime) {
        param.toTime = new Date(moment(this.toTime).format('YYYY/MM/DD') + ' 23:59:59').getTime()
      }
      let path = {
        projectId: projectId
      }
      companyProjectService.companyOprationList(param, path).then(ret => {
        if (+ret.code === 200) {
          if (ret.data.items.length === 0) {
            this.emptyLogo = true
            this.showPage = false
            this.loading = '暂无操作记录'
          } else {
            this.showPage = true
            this.emptyLogo = false
          }
          this.total = ret.data.totalCount
          this.tableData = ret.data.items
        } else {
          this.$message({
            type: 'error',
            message: '获取操作列表失败！'
          })
        }
      }).catch(reason => {
        this.$message({
          type: 'error',
          message: '获取操作列表失败！'
        })
      })
    },
    // 1.9 获取操作类型
    getOprationType () {
      let param = {
        detail: this.detail ? this.detail : null,
        account: this.account ? this.account : null
      }
      if (this.fromTime) {
        param.fromTime = new Date(this.fromTime).getTime()
      }
      if (this.toTime) {
        param.toTime = new Date(this.toTime).getTime() + 86400000
      }
      let path = {
        projectId: projectId
      }
      companyProjectService.companyOprationTypes(param, path).then(ret => {
        if (+ret.code === 200) {
          this.options = [{value: '', label: '全部'}]
          ret.data.map((item) => {
            this.options.push({
              value: item.code,
              label: item.name
            })
          })
        } else {
          this.$message({
            type: 'error',
            message: '获取操作类型失败！'
          })
        }
      }).catch(reason => {
        this.$message({
          type: 'error',
          message: '获取操作类型失败！'
        })
      })
    }
  },
  filters: {
    formatType: function (data) {
      return data ? operateType[data] : ''
    },
    // 1.3 时间格式化
    formatDate (data) {
      var date = new Date(data)
      return formatDate(date, 'yyyy.MM.dd hh:mm:ss')
    }
  },
  created () {
    projectId = this.$route.params.id
    this.getOprationType()
    this.getOprationList()
    const otherHeight = 350
    this.setTableHeight(otherHeight)
    // 窗口大小改变时 触发
    this.resizeHandle.resize(() => {
      this.setTableHeight(otherHeight)
    })
  }
}
</script>
<style lang="less" type="text/less">
  .project-logs {
    margin: 0 24px;

    .table-wrapper .table-body-wrapper {
      top: -2px;
    }

    .prj-title {
      font-size: 16px;
      font-weight: 500;
      color: #212530;
      line-height: 32px;
      margin-bottom: 16px;
      margin-top: 4px;
    }

    .prj-search {
      margin-bottom: 24px;
      font-size: 14px;
    }

    .table-wrapper .table-head-wrapper .table-head th {
      padding: 9px 16px;
      box-sizing: border-box;
      height: 40px;
    }

    .table-wrapper .table-body-wrapper {
      top: -2px;
    }

    .table-wrapper .table-body-wrapper > table {
      border-top: 0;
      border-bottom: 0;

      td {
        height: 56px;
        box-sizing: border-box;
        padding-left: 16px;
        padding-right: 16px;
      }
    }

    .sort {
      position: relative;
      top: 2px;
      left: 5px;
      display: inline-block;
      width: 8px;
      height: 12px;
      background: transparent url('~@/assets/images/sort.png') 0 0 no-repeat;
    }

    .sort-down {
      position: relative;
      top: 2px;
      left: 5px;
      display: inline-block;
      width: 8px;
      height: 12px;
      background: transparent url('~@/assets/images/sort.png') -22px 0 no-repeat;
    }

    .sort-up {
      position: relative;
      top: 2px;
      left: 5px;
      display: inline-block;
      width: 8px;
      height: 12px;
      background: transparent url('~@/assets/images/sort.png') -11px 0 no-repeat;
    }

    .opration_page {
      text-align: right;
      padding: 15px 0;
      z-index: 999;

      .w__pagination {
        text-align: right;
      }
    }
  }
</style>
